<template>
  <air-slider-captcha
    ref="verify"
    :maxFailCount="maxFailCount"
    :defaultText="defaultText"
    :successText="successText"
    :failText="failText"
    :size="size"
    :bgWidth="bgWidth"
    :blockWidth="blockWidth"
    :fetchCatpcha="getCaptcha"
    :validator="validateCaptcha"
    @change="onChange"
  >
  </air-slider-captcha>
</template>

<script>
import { fetchSliderCaptcha, verifySliderCaptcha } from '@/apis/common'

let state = ''
const sliderTokenKey = 'retail_slider_token'

export default {
  name: 'slider-verify',
  props: {
    /**
     * 失败多少次后刷新验证码
     */
    maxFailCount: {
      type: Number,
      default: 3
    },
    /**
     * 默认提示文案
     */
    defaultText: {
      type: String,
      default: '拖动滑块,完成拼图'
    },
    /**
     * 成功提示文案
     */
    successText: {
      type: String,
      default: '验证通过'
    },
    /**
     * 失败提示文案
     */
    failText: {
      type: String,
      default: '验证失败'
    },
    /**
     * 输入框大小
     * @values default, small, large
     */
    size: {
      type: String,
      default: 'default'
    },
    bgWidth: {
      type: Number,
      default: 310
    },
    blockWidth: {
      type: Number,
      default: 75
    }
  },
  methods: {
    // 获取滑块验证码
    async getCaptcha () {
      sessionStorage.removeItem(sliderTokenKey)

      try {
        const data = await fetchSliderCaptcha()
        state = data.state

        return {
          block: data.sliderImage,
          bg: data.backgroundImage
        }
      } catch (err) {
        this.$message.error(err.message)
        return Promise.reject(err)
      }
    },
    // 校验滑块验证码
    async validateCaptcha (value) {
      try {
        const data = await verifySliderCaptcha({
          newPercentage: (value / 310).toFixed(3) - 0,
          state: state
        })

        this.$emit('change', data)
        sessionStorage.setItem(sliderTokenKey, data)

        return data
      } catch (err) {
        if (err.code === 100020010) {
          this.refresh()
        }

        sessionStorage.removeItem(sliderTokenKey)

        return Promise.reject(err)
      }
    },
    onChange (value) {
      if (!value) {
        sessionStorage.removeItem(sliderTokenKey)
        this.$emit('change', '')
      }
    },
    refresh () {
      this.$refs.verify.onRefresh()
    },
    reloadVerify () {
      this.$refs.verify.onRefresh()
    }
  }
}
</script>
